import React, { useEffect, useRef } from 'react';
import useTranslationLgs from '@hooks/i18n/useTranslation';
import { LovWithoutIdDTO } from '@api/ringil-api.v2';
import { Dropdown } from '@components/RingilComponents/SafeDropdown';
import { deferStampDataTestIdOnDescendantRef, toTestIdSlug } from '@utils/testUtils';

interface ComponentProps {
  code: string;
  onChange: (code: string) => void;
  style?: any;
  disabled?: boolean;
  dataTestId?: string;
  dataTestIdItemPrefix?: string;
}

const InputIncoterm: React.FC<ComponentProps> = ({ onChange, code, style, disabled = false, dataTestId, dataTestIdItemPrefix }) => {
  const { tr } = useTranslationLgs();
  const wrapperRef = useRef<HTMLDivElement | null>(null);
  const model: LovWithoutIdDTO[] = [
    { name: tr('InputIncoterm.exw', 'EXW (Ex Works)'), code: 'EXW' },
    { name: tr('InputIncoterm.fca', 'FCA (Free Carrier)'), code: 'FCA' },
    { name: tr('InputIncoterm.cpt', 'CPT (Carriage Paid To)'), code: 'CPT' },
    {
      name: tr('InputIncoterm.cip', 'CIP (Carriage and Insurance Paid to)'),
      code: 'CIP',
    },
    { name: tr('InputIncoterm.dap', 'DAP (Delivered At Place)'), code: 'DAP' },
    {
      name: tr('InputIncoterm.dpu', 'DPU (Delivered At Place Unloaded)'),
      code: 'DPU',
    },
    { name: tr('InputIncoterm.ddp', 'DDP (Delivery Duty Paid)'), code: 'DDP' },
    { name: tr('InputIncoterm.fas', 'FAS (Free Alongside Ship)'), code: 'FAS' },
    { name: tr('InputIncoterm.fob', 'FOB (Free On Board)'), code: 'FOB' },
    { name: tr('InputIncoterm.cfr', 'CFR (Cost and Freight)'), code: 'CFR' },
    {
      name: tr('InputIncoterm.cif', 'CIF (Cost, Insurance and Freight)'),
      code: 'CIF',
    },
  ];

  useEffect(() => {
    return deferStampDataTestIdOnDescendantRef(wrapperRef, '.p-dropdown', dataTestId);
  }, [dataTestId]);

  return (
    <div ref={wrapperRef}>
      <Dropdown
        options={model}
        optionValue={'code'}
        optionLabel={'name'}
        value={code}
        onChange={e => onChange(e.value)}
        style={style}
        disabled={disabled}
        itemTemplate={(option: LovWithoutIdDTO) => (
          <span data-testid={dataTestIdItemPrefix ? `${dataTestIdItemPrefix}-${toTestIdSlug(option?.name || option?.code || '')}` : undefined}>{option?.name}</span>
        )}
      />
    </div>
  );
};

export default InputIncoterm;
